import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";
import { classify } from "shared/formatters/strings";
import { staticTerminals } from "../views/terminals/MetaData";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.collection("ExpressionTerminals", {

    initialize: function(models, { terminalMetaData } = {}) {
      this.terminalMetaData = terminalMetaData || {};
    },

    model: function(attrs, options) {
      const attributes = _.extend({}, attrs, { terminal: attrs.terminal.toLowerCase() });
      const terminalConfigurationData = options.collection.terminalMetaData[attributes.terminal] || staticTerminals[attributes.terminal] || {};

      const type = attributes.type || terminalConfigurationData.type || "unsupported";

      const modelClass = classify(`${type}_terminal`);
      return new app.Models[modelClass](attributes, options);
    },

    addTerminal: function(nodes, options) {
      if (nodes === undefined || nodes === null) { return; }
      nodes = _.flatten([nodes]);

      if (this._shouldAddConjunction()) {
        nodes.unshift({ terminal: 'and' });
      }

      this.add(nodes, options);
      if (this._shouldValidateOnAdd()) { this.trigger('validate'); }
    },

    expressionText: function() {
      return (
        this.map(function(node) {
          return node.text();
        }).join(" ").trim()
      );
    },

    expressionNodes: function() {
      return this.map(node => node.attributes);
    },

    removeTerminal: function(node) {
      var nodesToDelete = [node];
      if (node.isNotTerminal()) {
        nodesToDelete.push(this._identifyNotParens(node));
      } else if (this.length > 1) {
        nodesToDelete.push(this._identifyConditionAndParenTerminals(node));
      }

      this._removeTerminals(nodesToDelete);
    },

    isValid: function() {
      return _.every(this.models, function(node) {
        return (node.isValid());
      });
    },

    errorMessages: function() {
      return (
        _.compact(
          _.map(this.models, function(node) {
            return node.errorMessages();
          })
        )
      );
    },

    _shouldValidateOnAdd: function() {
      return this.length > 3 && (this._containsNotTerminal() || this._containsConjunction());
    },

    _containsNotTerminal: function() {
      return this.models.some(function(terminal) { return terminal.isNotTerminal(); });
    },

    _containsConjunction: function() {
      return this.models.some(function(terminal) { return terminal.isConjunctionTerminal(); });
    },

    _shouldAddConjunction: function() {
      return (
        this.length > 0 && !this.at(this.length - 1).isConjunctionTerminal()
      );
    },

    _isConjunctionTerminal: function(node) {
      return (
        node !== undefined && node.isConjunctionTerminal()
      );
    },

    _isNotTerminal: function(node) {
      return (
        node !== undefined && node.isNotTerminal()
      );
    },

    _identifyNotParens: function(node) {
      var nodePosition = this.indexOf(node);

      var leftTerminal = this.at(nodePosition - 1);
      var rightContainingTerminal = this.at(nodePosition + 2);
      if (this._areDelimiters(leftTerminal, rightContainingTerminal)) {
        return ([rightContainingTerminal, leftTerminal]);
      }
    },

    _identifyConditionAndParenTerminals: function(node) {
      var nodes = [];
      var nodePosition = this.indexOf(node);
      var rightPosition = nodePosition + 1;
      var leftPosition = nodePosition - 1;
      var rightTerminal = this.at(rightPosition);
      var leftTerminal = this.at(leftPosition);

      if (this._isNotTerminal(leftTerminal)) {
        nodes.push(leftTerminal);
        leftPosition = leftPosition - 1;
        leftTerminal = this.at(leftPosition);
      }

      while (this._areDelimiters(leftTerminal, rightTerminal)) {
        nodes.push(leftTerminal, rightTerminal);

        leftPosition = leftPosition - 1;
        rightPosition = rightPosition + 1;
        leftTerminal = this.at(leftPosition);
        rightTerminal = this.at(rightPosition);
      }

      if (this._isConjunctionTerminal(rightTerminal)) {
        nodes.push(rightTerminal);

        var rightContainingTerminal = this.at(rightPosition + 2);
        if (this._areDelimiters(leftTerminal, rightContainingTerminal)) {
          nodes.push(rightContainingTerminal, leftTerminal);
        }
      } else if (this._isConjunctionTerminal(leftTerminal)) {
        nodes.push(leftTerminal);

        var leftContainingTerminal = this.at(leftPosition - 2);
        if (this._areDelimiters(leftContainingTerminal, rightTerminal)) {
          nodes.push(leftContainingTerminal, rightTerminal);
        }
      }

      return nodes;
    },

    _areDelimiters: function(openingTerminal, closingTerminal) {
      return (
        closingTerminal !== undefined &&
        openingTerminal !== undefined &&
        openingTerminal.get('terminal') === '(' &&
        closingTerminal.get('terminal') === ')'
      );
    },

    _removeTerminals: function(nodes) {
      _.each(_.flatten(nodes), function(node) {
        this.remove(node);
      }, this);
    }
  });
});
